import { registerElementSafely as o } from "@cds/core/internal";
import { CdsIcon as r } from "./icon.element.js";
o("cds-icon", r);
